import React from 'react'
import { useTranslation } from 'react-i18next'

import UnauthorizedLayout from '../components/Auth/UnauthorizedLayout'

const SignupSuccessPage = () => {
  const { t } = useTranslation('auth')

  return (
    <UnauthorizedLayout
      title={t('signupSuccess.title')}
      subtitle={null}
      question={null}
      text={null}
    >
      <div className="max-w-xl mx-auto text-center px-4">
        <p className="text-base taller:text-lg text-white text-opacity-90">
          {t('signupSuccess.message')}
        </p>
      </div>
    </UnauthorizedLayout>
  )
}

export default SignupSuccessPage
